import "./App.css";
import DashBoard from "./pages/DashBoard";
import HomePage from "./pages/HomePage";
import McqResultPage from "./pages/McqResultPage";
import McqPracticePage from "./pages/McqPracticePage";
import { Route, Routes } from "react-router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProfilePage from "./pages/ProfilePage";
import { useEffect } from "react";
import Register from "./pages/Register";
import ReactGA from "react-ga4";
import TestReviewPage from "./pages/TestReviewPage";
import PrivateRoutes from "./components/commonComponents/PrivateRoutes";
import FeedbackPage from "./pages/FeedbackPage";
import SupportPage from "./pages/SupportPage";
import ResetPage from "./pages/ResetPage";
import AddQuestions from "./pages/AddQuestions";

const TRACKING_ID = "G-1NDFY8Q24K";
ReactGA.initialize(TRACKING_ID);

function App() {

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Home Page",
    });
  }, []);


  return (
    <div className="App">
      <ToastContainer />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/reset" element={<ResetPage />} />
        <Route path="/add" element={<AddQuestions />} />

        //Private Route for preventing unAuthorized usage.
        <Route element={<PrivateRoutes />}>
          <Route path="/dashboard" element={<DashBoard />} />
          <Route path="/practice/:topic/:difficulty/:noOfQuestions/" element={<McqPracticePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/testreview" element={<TestReviewPage />} />
        </Route>

      </Routes>
      {/* <McqResultPage/> */}
    </div>
  );
}

export default App;
